import React, { useEffect, useState } from 'react';
import TController from './components/view/TController';
import { IData } from './helpers/interface';
import { initialState } from './helpers/initialState';
import lodash, { forEach } from 'lodash';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../../components/ui/ChildHeader';
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import { useAuth } from '../../../services/auth/AuthProvider';
import { useQuery } from '../../../hooks/UseQuery';
import { processes } from './helpers/initialState';
import PartTable from './components/view/PartTable';
import ModalCustom from '../../../components/common/Modal';
import useConfirm from '../../../components/common/useConfirm';
import RejectionTable from './components/view/RejectionTable';

//   const ngQty = process.prod_qty - process.accepted_qty;
//   const totalRejectionQty = process.reasons_for_rej?.reduce(
//     (sum: number, item: any) => sum + +item.rej_qty,
//     0
//   );

//   if (totalRejectionQty - ngQty < 0) {
//     alert(`Please select ${ngQty - totalRejectionQty} more rejection Qty.`);
//     return true;
//   } else if (ngQty < totalRejectionQty) {
//     alert(`Please select ${totalRejectionQty - ngQty} less rejection Qty.`);
//     return true;
//   }
//   return false;
// };
const View = () => {
  const [moduleData, setModuleData] = useState<IData>(
    lodash.cloneDeep(initialState),
  );
  const [render, setRender] = useState(false);
  const [partIdx, setPartIdx] = useState(false);
  const navigate = useNavigate();
  const { state } = useAuth();
  const { id } = useParams();
  const isView = useQuery('isView') === 'true' ? true : false;
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isOpenPopupForRejections, setIsOpenPopupRejections] = useState(false);
  const documentType = useQuery('documentType') || '';
  const [rejectionsIndx, setRejectionsIndx] = useState(0);
  const [reasonType, setReasonType] = useState('');
  const [autoCompleteMachineValue, setAutoCompleteMachineValue] = useState<any>(
    Array.from({ length: 5 }, () => lodash.cloneDeep({})),
  );
  const heading = useQuery('heading') || '';

  const [DialogDeleteRow, confirmDeleteRow] = useConfirm(
    'DELETE',
    'Are you sure you want to delete Row?',
  );
  const [DialogAddRow, confirmAddRow] = useConfirm(
    'Add Row',
    'Are you sure you want to Add Row?',
  );
  const [DialogSubmit, confirmSubmit] = useConfirm(
    'Submit',
    'Are you sure you want to save this document?',
  );
  const [DialogSummary, confirmSummary] = useConfirm(
    'Submit',
    'Are you sure you want to add this to 4M summary?',
  );
  useEffect(() => {
    if (id) {
      axios
        .get(`/api/dailyProductionRecord/${id}`)
        .then((res) => {
          setModuleData(res.data);
          const machine = res.data.processes.map(
            (process: any, index: number) => process.mc_no || {},
          );

          setAutoCompleteMachineValue(machine);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  const handleSumbit = async (isSubmitted: boolean, submitType: string) => {
    if (submitType === 'forDailyProduction') {
      const ans = await confirmSubmit();
      if (!ans) return;
    }
    if (submitType === 'forSummary') {
      const ans = await confirmSummary();
      if (!ans) return;
    }
    moduleData.isSubmitted = isSubmitted;
    moduleData.is_admin_request = 'pending';
    if (id) {
      await axios
        .put(`/api/dailyProductionRecord/${id}`, moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Updated Successfully');
          }
        })
        .catch((err) => console.log(err));
    } else {
      moduleData.document_type = documentType;
      await axios
        .post('/api/dailyProductionRecord', moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('created Successfully');
            navigate(-1);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handelDeleteRows = async (rowIdx: number) => {
    const ans = await confirmDeleteRow();
    if (!ans) return;
    let data = { ...moduleData };
    data.processes.splice(rowIdx, 1);
    autoCompleteMachineValue.splice(rowIdx, 1);
    setModuleData(data);
  };

  return (
    <>
      <Box>
        <ChildHeader text={heading}>
          {!isView && (
            <>
              <CustomButton
                sx={{
                  backgroundColor: '#1c7ed6',
                }}
                onClick={async () => {
                  const ans = await confirmAddRow();
                  if (!ans) return;
                  Array(5)
                    .fill(null)
                    .forEach(() => {
                      moduleData.processes.push(lodash.cloneDeep(processes[0]));
                      autoCompleteMachineValue.push({});
                    });
                  setRender((prev) => !prev);
                }}
              >
                ADD ROWS
              </CustomButton>
              {state.user?.userType === state.IS.Supervisor && (
                <SaveButton
                  label="Save & Continue"
                  onClick={() => handleSumbit(false, 'forDailyProduction')}
                />
              )}
              <SubmitButton
                label="Submit"
                onClick={() => handleSumbit(true, 'forDailyProduction')}
              />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
          handleSumbit,
          autoCompleteMachineValue,
          handelDeleteRows,
          isOpenPopup,
          setIsOpenPopup,
          setPartIdx,
          setIsOpenPopupRejections,
          setRejectionsIndx,
          setReasonType,
        }}
      />

      <ModalCustom
        title="Part List"
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
        }}
      >
        <PartTable
          {...{
            moduleData,
            partIdx,
          }}
        />
      </ModalCustom>
      <ModalCustom
        title="Rejections List"
        openModal={isOpenPopupForRejections}
        closeModal={() => {
          setIsOpenPopupRejections(false);
        }}
      >
        <RejectionTable
          process={moduleData.processes[rejectionsIndx]}
          isView={isView}
          reasonType={reasonType}
        />
      </ModalCustom>
      <DialogDeleteRow isSubmitContent={false} />
      <DialogAddRow />
      <DialogSubmit />
      <DialogSummary />
    </>
  );
};

export default View;
